import React from "react";

/**
 * Page footer line: "Sponsored by X · © 2026 Aris" or whatever the API says.
 */
const Footer = ({ section }) => {
  if (!section) return null;
  const { sponsor_line, copyright_line } = section;
  if (!sponsor_line && !copyright_line) return null;
  return (
    <div className="corp-footer-line w-full">
      <span>
        {sponsor_line}
        {sponsor_line && copyright_line ? " · " : ""}
        {copyright_line}
      </span>
    </div>
  );
};

export default Footer;
